import { useState, useEffect } from 'react';

export default function useHash() {
    const [hash, setHash] = useState('');

      useEffect(() => {
        const handleHashChange = () => {
          setHash(decodeURIComponent(window.location.hash.substring(1))?.trim());
        };
        handleHashChange();
        window.addEventListener('hashchange', handleHashChange);

        return () => {
          window.removeEventListener('hashchange', handleHashChange);
        };
      }, []);

    return [hash];
}